import getOmeEntriesExportData from './GetOmeEntriesExportData';

const OmeEntriesExportData = { getOmeEntriesExportData };

export default OmeEntriesExportData;